import { withScalars } from "apollo-link-scalars";
import { Decimal } from "decimal.js";
import type { IntrospectionQuery } from "graphql";
import { buildClientSchema } from "graphql";
import { Duration } from "luxon";
import introspectionResult from "./generated.schema.json";

const schema = buildClientSchema(
  introspectionResult as unknown as IntrospectionQuery,
);

export const customScalarsLink = withScalars({
  schema,
  typesMap: {
    Decimal: {
      serialize: (parsed: unknown): string | null => {
        if (parsed === null) {
          return null;
        }

        if (parsed instanceof Decimal) {
          return parsed.toString();
        }

        throw new Error("Serialize Decimal expected to serialize a Decimal");
      },
      parseValue: (raw: unknown): Decimal | null => {
        if (raw === null) {
          return null;
        }

        if (raw instanceof Decimal) {
          return raw;
        }

        if (typeof raw === "string") {
          const d = new Decimal(raw as string);
          if (d) {
            return d;
          }
        }

        throw new Error("Parse Decimal expected to parse a string");
      },
    },
    DateTime: {
      serialize: (parsed: unknown): string | null => {
        if (parsed === null) {
          return null;
        }

        if (parsed instanceof Date) {
          return parsed.toISOString();
        }

        throw new Error(
          "Serialize DateTime expected to serialize a Javascript Date.",
        );
      },
      parseValue: (raw: unknown): Date | null => {
        if (!raw) {
          return null;
        }

        if (raw instanceof Date) {
          return raw;
        }

        if (typeof raw === "string") {
          const date = new Date(raw as string);
          if (date) {
            return date;
          }
        }

        throw new Error("Parse DateTime expected to parse a string.");
      },
    },
    ISO8601Duration: {
      serialize: (parsed: unknown): string | null => {
        if (parsed === null) {
          return null;
        }

        if (parsed instanceof Duration) {
          return parsed.toISO();
        }

        throw new Error(
          "Serialize ISO8601Duration expected to serialize a luxon Duration",
        );
      },
      parseValue: (raw: unknown): Duration | null => {
        if (!raw) {
          return null;
        }

        if (raw instanceof Duration && raw.isValid) {
          return raw;
        }

        if (typeof raw === "string") {
          const duration = Duration.fromISO(raw);
          if (duration.isValid) {
            return duration;
          }
        }

        throw new Error(
          "Parse ISO8601Duration expected to parse a valid string",
        );
      },
    },
  },
});
